export const createTagValue = (creatorId: string, termValue?: string) => {
  const parts = [creatorId, termValue].filter(Boolean);

  return parts.join('-');
};
